export default __webpack_public_path__ + "static/media/cenblz.f1e46008.png";